module.exports = __webpack_public_path__ + "img/img40.135951d5.svg";